<template>
	<div class="hair-attendance">
		<div class="hair-attendance-top">考勤统计</div>
		<div class="hair-attendance-content">
			<el-time-select v-model="value" :picker-options="{
        start: '08:30',
        step: '00:15',
        end: '18:30'}" placeholder="选择时间"></el-time-select>
			<el-button type="primary" class="hair-attendance-content-right">导出数据</el-button>
		</div>
		<div class="hair-attendance-satistics">
			<ul class="hair-attendance-satistics-item">
				<li v-for="(item,index ) in satistics" :key="index" class="hair-attendance-satistics-item-li">
					{{item}}
					<br />
					<span>{{statisticalData[index]}}</span>
				</li>
			</ul>
		</div>
		<div class="hair-attendance-title">
			<el-time-select v-model="value1" :picker-options="{
        start: '08:30',
        step: '00:15',
        end: '18:30'}" placeholder="选择时间"></el-time-select>
			<el-button type="primary" style="padding: 5px 15px; margin-left: 10px;">筛选</el-button>
			<div class="hair-attendance-title-right">
				<el-button plain class="hair-attendance-title-right-item">上月指标</el-button>
				<el-button plain class="hair-attendance-title-right-item">本月指标</el-button>
				<el-button plain class="hair-attendance-title-right-item">下月指标</el-button>
				<el-button type="primary" class="hair-attendance-title-right-item">编辑</el-button>
			</div>
		</div>
		<el-table :data="tableData" border style="width: 1261px; margin-top: 20px">
			<el-table-column prop="Monday" label="星期一" width="180"></el-table-column>
			<el-table-column prop="Tuesday" label="星期二" width="180"></el-table-column>
			<el-table-column prop="Wednesday" label="星期三" width="180"></el-table-column>
			<el-table-column prop="Thursday" label="星期四" width="180"></el-table-column>
			<el-table-column prop="Friday" label="星期五" width="180"></el-table-column>
			<el-table-column prop="Saturday" label="星期六" width="180"></el-table-column>
			<el-table-column prop="Sunday" label="星期日" width="180"></el-table-column>
		</el-table>
		<div class="hair-attendance-bottom">
			<span class="hair-attendance-bottom-item1">
				<i style="border: 1px solid rgba(0,0,0,.2);"></i>正常
			</span>
			<span class="hair-attendance-bottom-item2">
				<i style="background-color: #fd6a7e;"></i>迟到/早退
			</span>
			<span class="hair-attendance-bottom-item3">
				<i style="background-color: #fb4d93;"></i>事假
			</span>
			<span class="hair-attendance-bottom-item4">
				<i style="background-color: #30ddce;"></i>病假
			</span>
			<span class="hair-attendance-bottom-item5">
				<i style="background-color: #8563fd;"></i>调休
			</span>
			<span class="hair-attendance-bottom-item6">
				<i style="background-color: #c6fc68;"></i>其他
			</span>
			<span class="hair-attendance-bottom-item7">
				<i style="background-color: #f32e2b;"></i>未打卡
			</span>
		</div>
		<div class="hair-attendance-whether">
			<el-button class="whether-item" plain style="padding: 5px 15px;">取消</el-button>
			<el-button class="whether-item" type="primary" style="margin-left: 40px; padding: 5px 15px;">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "hairAttendance",
		data() {
			return {
				value: "",
				value1: "",
				statisticalData: [23, 11, 11, 45, 23, 7, 23, 0, 0, 0, 0],
				satistics: [
					"排班 (天)",
					"迟到 (分钟)",
					"早退 (分钟)",
					"加班 (小时)",
					"旷工 (天)",
					"事假 (天)",
					"病假 (天)",
					"婚假 (天)",
					"产假 (天)",
					"生日假 (天)",
					"调休 (天)",
				],
				tableData: [{
					Monday: "",
					Tuesday: "",
					Wednesday: "07-01",
					Thursday: "07-02",
					Friday: "07-03",
					Saturday: "07-04",
					Sunday: "07-05",
				}, {
					Monday: "07-06",
					Tuesday: "07-07",
					Wednesday: "07-08",
					Thursday: "07-09",
					Friday: "07-10",
					Saturday: "07-11",
					Sunday: "07-12",
				}, {
					Monday: "07-13",
					Tuesday: "07-14",
					Wednesday: "07-15",
					Thursday: "07-16",
					Friday: "07-17",
					Saturday: "07-18",
					Sunday: "07-19",
				}, {
					Monday: "07-20",
					Tuesday: "07-21",
					Wednesday: "07-22",
					Thursday: "07-23",
					Friday: "07-24",
					Saturday: "07-25",
					Sunday: "07-026",
				}, {
					Monday: "07-27",
					Tuesday: "07-28",
					Wednesday: "07-29",
					Thursday: "07-30",
					Friday: "",
					Saturday: "",
					Sunday: "",
				}, ],
			};
		},
		created() {
			console.log('====');
		}
	};
</script>

<style>
	.hair-attendance-top {
		margin: 20px 0;
		border-left: 8px solid #429bfe;
		padding-left: 15px;
	}

	.hair-attendance-content-right {
		padding: 5px 15px;
		position: absolute;
		right: 20px;
	}

	.hair-attendance-satistics-item {
		display: flex;
		padding: 0;
	}

	.hair-attendance-satistics-item li:nth-child(1) {
		margin-left: 0;
	}

	.hair-attendance-satistics-item-li {
		width: 140px;
		height: 140px;
		text-align: center;
		padding-top: 20px;
		list-style: none;
		background-color: #f6f5f8;
		box-sizing: border-box;
		margin-left: 10px;
	}

	.hair-attendance-satistics-item-li span {
		line-height: 80px;
		font-size: 24px;
	}

	.hair-attendance-title {
		position: relative;
		margin-top: 30px;
	}

	.hair-attendance-title-right {
		position: absolute;
		right: 400px;
		top: 0;
	}

	.hair-attendance-title-right-item {
		padding: 5px 15px;
	}

	.hair-attendance .is-leaf {
		text-align: center;
		background-color: #faf7fa;
	}

	.hair-attendance .el-table__row td {
		height: 100px;
		text-align: center;
	}

	.hair-attendance-bottom {
		margin-top: 40px;
	}

	.hair-attendance-bottom span:nth-child(n) {
		margin: 0 30px;
		position: relative;
	}

	.hair-attendance-bottom span i {
		position: absolute;
		top: 5px;
		left: -24px;
		width: 12px;
		height: 12px;
		border-radius: 12px;
	}

	.hair-attendance .el-table__row:nth-child(4) td:nth-child(3):before {
		content: " ";
		position: absolute;
		top: 73px;
		left: 85px;
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #8563fc;
	}

	.hair-attendance .el-table__row:nth-child(3) td:nth-child(4):before {
		content: " ";
		position: absolute;
		top: 73px;
		left: 85px;
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #30ddce;
	}

	.hair-attendance-whether {
		margin: 80px 300px;
	}
</style>